<template>
  <div
    class="qr-kpi-card"
    :class="{ 'qr-kpi-card--highlight': highlight }"
  >
    <div class="qr-kpi-card__top">
      <span class="qr-kpi-card__title">{{ title }}</span>
      <div
        v-if="icon"
        class="qr-kpi-card__icon-wrap"
        :style="iconWrapStyle"
      >
        <feather-icon
          :icon="icon"
          svgClasses="qr-kpi-card__icon"
          :style="iconStyle"
        />
      </div>
    </div>

    <div class="qr-kpi-card__value">{{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "QrKpiCard",
  props: {
    title: { type: String, required: true },
    value: { type: String, required: true },
    highlight: { type: Boolean, default: false },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "#6366F1" },
  },
  computed: {
    iconWrapStyle() {
      if (this.highlight) {
        return { background: "rgba(255, 255, 255, 0.2)" };
      }
      return { background: this.hexToRgba(this.iconColor, 0.12) };
    },
    iconStyle() {
      return {
        color: this.highlight ? "#fff" : this.iconColor,
      };
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      const normalized = String(hex || "").replace("#", "");
      const value =
        normalized.length === 3
          ? normalized
              .split("")
              .map((c) => c + c)
              .join("")
          : normalized.slice(0, 6);
      const r = parseInt(value.slice(0, 2), 16) || 99;
      const g = parseInt(value.slice(2, 4), 16) || 102;
      const b = parseInt(value.slice(4, 6), 16) || 241;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped lang="scss">
.qr-kpi-card {
  background: #fff;
  border-radius: 18px;
  padding: 1.15rem 1.25rem 1.15rem;
  box-shadow: 0 1px 2px 0 rgba(20, 21, 34, 0.04);
  border: 1px solid #ececf2;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &--highlight {
    background: linear-gradient(128.53deg, #0f9d58 0%, #16a34a 100%);
    border-color: transparent;

    .qr-kpi-card__title,
    .qr-kpi-card__value {
      color: #fff;
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
  }

  &__title {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    line-height: 1.3;
  }

  &__icon-wrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
  }

  &__icon {
    width: 16px;
    height: 16px;
  }

  &__value {
    margin-top: auto;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.04em;
    color: #16172b;
  }
}
</style>
